import { useEffect, useState } from "react";
import moment from "moment";
import { CgCalendarDates } from "react-icons/cg";
import "./xpressContainer.css";

const MENU_TYPES = ["", "Breakfast", "Lunch", "Snacks", "Dinner"];

const XpressContainer = ({
  totalOrders,
  date,
  handleDateChange,
  setSearchOrderID,
  menuTypeValue,
  onMenuTypeChange,
  onTimeSlotChange,
  timeSlotOptions,
  timeSlotValue
}) => {
  const [menuType, setMenuType] = useState(menuTypeValue);
  const [timeSlot, setTimeSlot] = useState(timeSlotValue);

  useEffect(() => {
    setTimeSlot(timeSlotValue);
  }, [timeSlotValue]);

  const chooseMenuType = (val) => {
    setMenuType(val);
    onMenuTypeChange?.(val);
  };
  const chooseTimeSlot = (val) => {
    setTimeSlot(val);
    onTimeSlotChange?.(val);
  };

  return (
    <div>
      <div className="xpressSection">
        <label className="calender">
          <CgCalendarDates size={22} color="#FFFFFF" />
          {moment(date).format("dddd, ")}
          <input
            type="date"
            value={date}
            onChange={handleDateChange}
            className="dateInput"
          />
        </label>

        <label className="xpressTotalOrderCount">
          Total Orders&nbsp;–&nbsp;{totalOrders}
        </label>
      </div>

      <div className="xpressSection align-items-center">
        <div className="flex-grow-1 mr-3 mt-1">
          <input
            type="text"
            className="form-control"
            placeholder="Search Order ID"
            onChange={(e) => setSearchOrderID(e.target.value)}
          />
        </div>

        <div className="dropdown mr-2">
          <button
            className="btn btn-primary dropdown-toggle"
            id="menuTypeDrop"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            type="button"
          >
             {menuType || "All"}
          </button>
          <div
            className="dropdown-menu dropdown-menu-right"
            aria-labelledby="menuTypeDrop"
          >
            {MENU_TYPES.map((t) => (
              <button
                key={t || "All"}
                className="dropdown-item"
                type="button"
                onClick={() => chooseMenuType(t)}
              >
              {t || "All"}
              </button>
            ))}
          </div>
        </div>

        <div className="dropdown">
          <button
            className="btn btn-primary dropdown-toggle"
            id="timeSlotDrop"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            type="button"
          >
            {timeSlot}
          </button>
          <div
            className="dropdown-menu dropdown-menu-right"
            aria-labelledby="timeSlotDrop"
          >
            {timeSlotOptions.map((s) => (
              <button
                key={s}
                className="dropdown-item"
                type="button"
                onClick={() => chooseTimeSlot(s)}
              >
                {s}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default XpressContainer;
